var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhp = function SvgPhp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6.1 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18.1 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.6 10.5 18.1 6h4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#576D7E",
    d: "M19.6 19.5c0 .413-.337.75-.75.75H2.35a.75.75 0 0 1-.75-.75V12c0-.412.338-.75.75-.75h16.5c.413 0 .75.338.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.924 14.21c0-.198.156-.415.408-.415h1.385c.78 0 1.482.523 1.482 1.524 0 .948-.702 1.475-1.482 1.475H5.715v.792c0 .265-.167.414-.383.414a.405.405 0 0 1-.408-.414zm.791.341v1.494h1.002c.402 0 .72-.354.72-.726 0-.42-.318-.768-.72-.768zM8.841 17.628v-3.406c0-.216.156-.372.426-.372.21 0 .366.156.366.372v1.308h1.954v-1.308c0-.216.192-.372.408-.372.21 0 .372.156.372.372v3.406c0 .21-.163.372-.372.372-.216 0-.408-.162-.408-.372v-1.312H9.633v1.312c0 .21-.156.372-.366.372-.27 0-.426-.162-.426-.372M13.21 14.21c0-.198.155-.415.407-.415h1.385c.78 0 1.483.523 1.483 1.524 0 .948-.702 1.475-1.482 1.475H14v.792c0 .265-.168.414-.384.414a.405.405 0 0 1-.408-.414zm.791.341v1.494h1.002c.402 0 .72-.354.72-.726 0-.42-.319-.768-.72-.768z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M18.85 20.25H4.6V21h14.25c.413 0 .75-.337.75-.75v-.75c0 .413-.337.75-.75.75"
  })));
};
export default SvgPhp;